import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { messages, TABLE_QUERY_KEYS } from 'app/config/constants';
import { queryClient } from 'app/app';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import { CaseRevisionModel, CaseRevisionsDataModel } from '../model/case-revision.model';
import {
  deleteCaseRevision,
  fetchCaseRevisions,
  getCaseRevision, getCaseRevisionData,
  saveCaseRevision, saveCaseRevisionData
} from './case-revision.service';
import { toast } from 'react-toastify';
import error = toast.error;
import success = toast.success;
import { values } from 'lodash';

export const fetchCaseRevisionQuery = (idMainProjectRevision: string) => {
  return useQuery({
    queryKey: ['main-project-revision', idMainProjectRevision],
    queryFn: () => getCaseRevision(idMainProjectRevision),
    enabled: !!idMainProjectRevision,
  });
};

export const updateCaseRevisionQuery = (uuid: string, resetForm: Function, successCallback: Function) => {
  return useMutation({
    mutationFn: (data: CaseRevisionModel) => saveCaseRevision(uuid, data),
    onSuccess: (data: CaseRevisionModel) => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.CASE_REVISION_TABLE] });
      resetForm({ values: data });
      successCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchCaseRevisionsTableQuery = (pagination: PaginationState, uuid: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.CASE_REVISION_TABLE, { ...pagination }, uuid],
    queryFn: ({ signal }) => fetchCaseRevisions({ signal, pagination, uuid }),
  });
};

export const deleteCaseRevisionQuery = () => {
  return useMutation({
    mutationFn: (idMainProjectRevision: number) => deleteCaseRevision(idMainProjectRevision),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.CASE_REVISION_TABLE] });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const saveCaseRevisionDataQuery = (uuid: string) => {
  return useMutation({
    mutationFn: (caseRevisionData: CaseRevisionsDataModel) => saveCaseRevisionData(uuid, caseRevisionData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['case-revision-data'] });
      showToast(success, messages.DATA_SAVED)
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const getCaseRevisionDataQuery = (uuid: string) => {
  return useQuery({
    queryKey: ['case-revision-data', { uuid: uuid}],
    queryFn: ({ signal }) => getCaseRevisionData(uuid),
  });
};

